import { render, staticRenderFns } from "./ResultEditor.vue?vue&type=template&id=a8964fc8&scoped=true&"
import script from "./ResultEditor.vue?vue&type=script&lang=js&"
export * from "./ResultEditor.vue?vue&type=script&lang=js&"
import style0 from "./ResultEditor.vue?vue&type=style&index=0&id=a8964fc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8964fc8",
  null
  
)

export default component.exports